export default {
  'menu.openItem.add.item': '添加临时菜',

  'menu.openItem.description.title': '适用场景：用于对菜单上不存在的菜品进行点餐',
  'menu.openItem.description.instructions': '使用方法',
  'menu.openItem.description.instructions.step1': '1. 在此处配置临时菜模板',
  'menu.openItem.description.instructions.step2': '2. 服务员在pos上选择所需的临时菜模板',
  'menu.openItem.description.instructions.step3': '3. 服务员自定义临时菜的名称、价格、打印机，然后送厨加工',

  'menu.openItem.table.column.name': '名称',
  'menu.openItem.table.column.salesCategory': '销售分类',
  'menu.openItem.table.column.taxInclusionOption': '是否含税',
  'menu.openItem.table.column.taxRate': '税率',
  'menu.openItem.delete.secondaryConfirmationPrompt': '确认要删除此临时菜？',

  'menu.openItem.edit.item': '编辑临时菜',

  'menu.openItem.form.basicInfo': '基本信息',
  'menu.openItem.form.taxes': '税',
  'menu.openItem.form.field.name': '菜品英文名',
  'menu.openItem.form.field.name.required': '菜品英文名必填',
  'menu.openItem.form.field.foreignName': '菜品中文名',
  'menu.openItem.form.field.taxCode': '税率代码',
  'menu.openItem.form.field.taxCode.required': '税率代码必选',
  'menu.openItem.form.field.taxInclusionOption': '是否含税',
  'menu.openItem.form.field.taxInclusionOption.prompt': `
    选择不含税，则菜品价格中不包含税额，会根据税率产生额外的税费
  `,
  'menu.openItem.form.field.salesCategory': '销售分类',
  'menu.openItem.form.field.salesCategory.prompt': '使用该临时菜产生的销售额将计入所选的销售分类下',
};
